import React from "react";
import Services from "../../api/service";
import { Link } from "react-router-dom";

const ServiceSidebar = (props) => {
  const SubmitHandler = (e) => {
    e.preventDefault();
  };

  const ClickHandler = () => {
    window.scrollTo(10, 0);
  };

  return (
    <div className="col-lg-4 col-md-8">
      <div className="wpo-single-sidebar">
        <div className="wpo-service-widget widget">
          <h2>All Services</h2>
          <ul>
            {props.services.slice(0, 6).map((service, Sitem) => (
              <li key={Sitem}>
                <Link
                  onClick={ClickHandler}
                  to={`/service-single/${service.id}`}
                >
                  {service?.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>
        {/* <div className="wpo-newsletter-widget widget">
          <h2>Newsletter</h2>
          <p>Join 20,000 Sabscribers!</p>
          <form className="form" onSubmit={SubmitHandler}>
            <input type="email" placeholder="Email Address" required />
            <button type="submit">Sign Up</button>
          </form>
          <span>
            By signing up you agree to our <Link to="#">Privecy Policy</Link>
          </span>
        </div>
        <div className="wpo-instagram-widget widget">
          <h2>Instagram Shot</h2>
          <ul>
            {Services.slice(0, 6).map((service, Sitem) => (
              <li key={Sitem}>
                <img src={service.sImg} alt="" />
              </li>
            ))}
          </ul>
        </div> */}
        <div className="wpo-contact-widget widget">
          <h2>
            How We Can <br /> Help You!
          </h2>
          <p>
            labore et dolore magna aliqua. Quis ipsum suspendisse ultrices
            gravida. Risus commodo viverra maecenas accumsan lacus vel
            facilisis.{" "}
          </p>
          <Link to="/contact">Contact Us</Link>
        </div>
      </div>
    </div>
  );
};

export default ServiceSidebar;
